export default __webpack_public_path__ + "static/media/top_mediterranean_sailing_spots_for_your_vacation.f4bc9297.webp";